import React from "react";
import clsx from "clsx";

import { TableRow, TableCell, Box, Typography } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router";

const useStyles = makeStyles((theme) => ({
    tableRowRoot: {
        position: "relative",
        transition: "all .2s",
        borderTop: `solid 1px ${theme.palette.borderColor.main}`,
        "&:hover, &.active": {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            "& $tableCellRoot, & $titleRoot": {
                color: theme.palette.text.primary,
            },
        },
        "&:last-child": {
            borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
        },
        "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: `0 3px 10px 0 ${alpha(theme.palette.common.dark, 0.2)}`,
            borderTopColor: "transparent",
        },
        "&.collapse-table-row": {
            borderTop: "0 none",
            "& $tableCellRoot": {
                padding: 0,
            },
        },
        "&.active": {
            borderTop: "0 none",
            "&:hover": {
                transform: "none",
                boxShadow: "none",
            },
        },
    },
    tableCellRoot: {
        padding: 6,
        fontSize: 14,
        letterSpacing: 0.25,
        color: theme.palette.text.secondary,
        borderBottom: "0 none",
        position: "relative",
        "&:first-child": {
            paddingLeft: 24,
        },
        "&:last-child": {
            textAlign: "right",
            paddingRight: 24,
        },
    },
    tableCellFirst: {
        width: "20%",
        minWidth: "150px",
    },
    tableCellLast: {
        width: 'fitContent'
    },
    titleRoot: {
        color: theme.palette.text.secondary,
        letterSpacing: 0.25,
    },
    createIconContainer: {
        background: "transparent",
        color: theme.palette.primary.main,
        width: "35px",
        height: "35px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "5px",
        cursor: "pointer",
    },
    tableActionContainer: {
        direction: "rtl",
    },
    status: {
        fontSize: '14px',
        marginRight: '5px'
    }
}));

const TicketsTableItem = ({ row }) => {
    const classes = useStyles();
    const history = useHistory();

    const getStatus = (status) => {
        if (status === "WaitingForResponse") {
            return "منتظر پاسخگویی"
        } else if (status === "Responded") {
            return "پاسخ داده شده"
        }
    }

    return (
        <>
            <TableRow className={clsx(classes.tableRowRoot)}>
                <TableCell
                    className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
                >
                    {row?.subject}
                </TableCell>
                <TableCell
                    className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
                >
                    {row?.guest?.fullName}
                </TableCell>
                <TableCell
                    className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
                >
                    {row?.guest?.codePersoneli}
                </TableCell>
                <TableCell
                    className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
                >
                    {row?.guest?.codeMeli}
                </TableCell>
                <TableCell
                    className={clsx(classes.tableCellRoot, classes.tableActionContainer)}
                >

                    <Typography className={classes.status} >
                        {getStatus(row?.status)}
                    </Typography>
                </TableCell>
                <TableCell
                    className={clsx(classes.tableCellRoot, classes.tableCellLast)}
                >
                    <Box
                        className={classes.createIconContainer}
                        onClick={() => history.push(`/ticketDetails/${row._id}`)}
                    >
                        نمایش
                    </Box>
                </TableCell>
            </TableRow>
        </>
    );
};

export default TicketsTableItem;